export const headers ={
    home:'בית',
    about:'אודות',
    projects:{
        ganim:'גנים ירוקים',
        geulim:'גאולים 15',
        ground_floor:'גנים ירוקים - צמודי קרקע',
        geulim_5:'גאולים 5',
        migdal:'פרוייקט במושבה מגדל (ליד הכינרת)',
    },
    contact:'צור קשר'
}

export const routes ={
    home:'/',
    about:'/about',
    projects:{
        ganim:'/project/Green_Graden',
        geulim:'/project/Geulim',
        ground_floor:'/project/ground_floor',
        geulim_5:'/project/geulim_5',
        migdal:'/project/migdal_kineret',
    },
    contact:'/contact'
}